import UserSmallHeader from 'components/Headers/UserSmallHeader';

import { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { PropostaVersao } from 'models/PropostaVersao';
import Proposta from 'models/Proposta';
import { PropostaVersaoParcelas } from 'models/PropostaVersaoParcelas';
import formatCurrency from 'utils/formatCurrency';
import api from 'services/api';
import { useQuery } from 'react-query';

import { Col, Row } from 'reactstrap';
import FloatingButton from 'components/FloatingButton';
import { FaPrint } from 'react-icons/fa';
import { CircularProgress } from '@material-ui/core';
import config from 'config';
import { PropostaConfiguracao } from 'models/PropostaConfiguracao';
import { Container, Typography } from './styles';

import Cabecalho from './components/Cabecalho';
import Titulo from './components/Titulo';
import FornecedoraFaturamento from './components/FornecedoraFaturamento';
import Equipamento from './components/Equipamento';
import AceiteClausulas from './components/AceiteClausulas';

import LogoImg from './components/Cabecalho/assets/img/logo_fck.png';

import './style.css';
import CondicoesFornecimento from './components/CondicoesFornecimento';
import CondicoesPagamento from './components/CondicoesPagamento';
import VendorList from './components/VendorList';
import Parcelas from './components/Parcelas';

interface LocationState {
  proposta: Proposta;
  propostaVersao: PropostaVersao;
}

interface PropostaImpressaoContext {
  proposta: Proposta;
  propostaVersao: PropostaVersao;
  isPropostaExterior: boolean;
  setIsPropostaExterior: (valor: boolean) => void;
  valorDolar: number;
  setValorDolar: (valor: number) => void;
  parcelas: PropostaVersaoParcelas[];
}

export const PropostaImpressaoContext = createContext(
  {} as PropostaImpressaoContext,
);

export default function PropostaImpressao(): JSX.Element {
  const location = useLocation<LocationState>();
  const { proposta: pProposta, propostaVersao: pVersao } = location.state;
  const [parcelas, setParcelas] = useState<PropostaVersaoParcelas[]>([]);
  const [propostaConfiguracoes, setPropostaConfiguracoes] = useState<
    PropostaConfiguracao[]
  >([]);
  const [propostaVersao, setPropostaVersao] = useState<PropostaVersao>(pVersao);
  const [proposta, setProposta] = useState<Proposta>(pProposta);

  const [isPropostaExterior, setIsPropostaExterior] = useState(false);
  const [isLoadingPropostaVersao, setIsLoadingPropostaVersao] = useState(false);
  const [valorDolar, setValorDolar] = useState(0);

  const { data: queryPropostaVersaoParcelas, isLoading: isLoadingParcelas } =
    useQuery(
      `parcelas-proposta-versao-${pVersao.id}`,
      async () => {
        async function getParcelas(): Promise<PropostaVersaoParcelas[]> {
          const response = await api.get(
            `/proposta/versao/${pVersao.id}/parcelas`,
          );
          return response.data;
        }

        const dataMeioPagamento = await getParcelas();
        return dataMeioPagamento;
      },
      { staleTime: 1000 },
    );

  /* const { data: queryPropostaVersao, isLoading: isLoadingPropostaVersao } =
    useQuery(
      `proposta-versao-${pVersao.id}`,
      async () => {
        async function getVersao(): Promise<PropostaVersao> {
          const response = await api.get(`/proposta/versao/${pVersao.id}`);
          return response.data;
        }

        const dataVersao = await getVersao();
        return dataVersao;
      },
      { staleTime: 10 },
    ); */

  const { data: queryProposta, isLoading: isLoadingProposta } = useQuery(
    `proposta-${pProposta.id}`,
    async () => {
      async function getProposta(): Promise<Proposta> {
        const response = await api.get(`/proposta/${pProposta.id}`);
        return response.data;
      }

      const data = await getProposta();
      return data;
    },
    { staleTime: 1000 },
  );

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    if (queryPropostaVersaoParcelas?.length) {
      setParcelas(queryPropostaVersaoParcelas);
    }
  }, [queryPropostaVersaoParcelas]);

  async function carregarVersao() {
    async function getVersao(): Promise<PropostaVersao> {
      setIsLoadingPropostaVersao(true);
      const response = await api.get(`/proposta/versao/${pVersao.id}`);
      return response.data;
    }

    const queryPropostaVersao = await getVersao();

    setIsLoadingPropostaVersao(false);
    setPropostaVersao(queryPropostaVersao);
    setValorDolar(queryPropostaVersao?.valorDolar || 0);

    setPropostaConfiguracoes(queryPropostaVersao?.PropostaConfiguracao || []);
  }

  useEffect(() => {
    carregarVersao();
  }, []);

  /*
  useEffect(() => {
    if (queryPropostaVersao) {
      setPropostaVersao(queryPropostaVersao);
      setValorDolar(queryPropostaVersao?.valorDolar || 0);

      setPropostaConfiguracoes(queryPropostaVersao?.PropostaConfiguracao || []);
    }
  }, [queryPropostaVersao]); */

  useEffect(() => {
    if (queryProposta) {
      setProposta(queryProposta);
      setIsPropostaExterior(queryProposta.PropostaLocalObra?.exterior || false);
    }
  }, [queryProposta]);

  function AvisoPropostaOrientativa({
    position,
  }: {
    position: string;
  }): JSX.Element {
    return (
      <div className={`marca-dagua ${position} text-center`}>
        <h2>
          {config.type === 'develop'
            ? 'AMBIENTE DE DESENVOLVIMENTO'
            : 'AMBIENTE DE HOMOLOGAÇÃO'}{' '}
          <br />
          Informações não oficiais.
        </h2>
      </div>
    );
  }

  return (
    <>
      <UserSmallHeader />

      <Container>
        {config.type !== 'production' && (
          <>
            <AvisoPropostaOrientativa position="top" />
          </>
        )}

        <PropostaImpressaoContext.Provider
          value={{
            proposta,
            propostaVersao,
            parcelas,
            isPropostaExterior,
            setIsPropostaExterior,
            valorDolar,
            setValorDolar,
          }}
        >
          <Cabecalho />
          <div className="mt-5">
            <Titulo />
          </div>
          <FornecedoraFaturamento />
          <Row>
            <Typography variant="h6" className="float-left">
              <strong>1 - EQUIPAMENTO</strong>
            </Typography>
          </Row>
          {propostaConfiguracoes?.map(propostaConfiguracao => (
            <Equipamento
              propostaConfiguracao={propostaConfiguracao}
              isPropostaExterior={isPropostaExterior}
              valorDolar={valorDolar}
              propostaVersao={propostaVersao}
            />
          ))}
          <Row className="my-3">
            <Col>
              <Typography variant="h6" className="float-left">
                <strong>PREÇO TOTAL DA PROPOSTA</strong>
              </Typography>
            </Col>
            <Col>
              <Typography variant="h6" className="float-right">
                <strong>{formatCurrency(propostaVersao?.valorFinal, 2)}</strong>
              </Typography>
            </Col>
          </Row>

          <CondicoesFornecimento />
          <CondicoesPagamento />
          <VendorList />
          {isLoadingParcelas ? (
            <Row>
              <Col className="text-center mb-4">
                <CircularProgress />
              </Col>
            </Row>
          ) : (
            <Parcelas />
          )}
          <AceiteClausulas />
        </PropostaImpressaoContext.Provider>

        <div className="mt-5">
          {config.type !== 'production' && (
            <>
              <AvisoPropostaOrientativa position="middle" />
            </>
          )}
        </div>

        <FloatingButton
          disabled={
            isLoadingParcelas || isLoadingProposta || isLoadingPropostaVersao
          }
          className="hide-on-print"
          onClick={() => window.print()}
        >
          <FaPrint />
        </FloatingButton>
      </Container>
    </>
  );
}
